import React, { useContext } from 'react';
import { ModalBody } from 'reactstrap';
import { color } from '~/assets/styles/colors';

import ReactGA from 'react-ga4';

import { PedidoContext } from '~/context/PedidoContext';
import { ExtratoContext } from '~/context/ExtratoContext';

import { ModalContent, StyledModal, ButtonStyle, DivButton, ImgAlert } from './styles';

import { Text } from "../../Text";
import Anuncio from '../../../assets/img/anuncio.svg';
import Exclamacao from '../../../assets/img/exclamacao.svg';

function ModalVisualizar({ setLoading, setMeusPedidos, user, numPedido, modalOpen, setModalOpen, switchButton }) {

	const toggleModal = () => {
		setModalOpen(!modalOpen);
	};

	const { getPedidos, aprovarOuReprovarPedido } = useContext(PedidoContext);
	const { getSaldo, getExtrato } = useContext(ExtratoContext);

	// useEffect(() => {
	// 	if (modalOpen) {
	// 		getPedidoIndividual(idPedido.toString(), 'recebidos');
	// 	}
	// }, [modalOpen]);

	function handleClickAprovarCobrança() {
		ReactGA.event({
			category: "aprovar_cobranca",
			action: "Aprovar Pedido",
			label: "Aprovando Pedido",
		});
	}

	function handleClickNegarCobrança() {
		ReactGA.event({
			category: "negar_cobranca",
			action: "Negar Pedido",
			label: "Negando Pedido",
		});
	}

	return (
		<div>
			<StyledModal isOpen={modalOpen} toggle={toggleModal} size="lg">
				<ModalContent open={modalOpen}>
					<ImgAlert
						alt={`${switchButton === 'aprovar' ? 'anuncio' : 'exclamacao'}`}
						width="130"
						src={switchButton === 'aprovar' ? Anuncio : Exclamacao}
					/>
					<ModalBody style={{
						color: switchButton === 'aprovar' ? color.black : color.red,
						fontSize: '30px'
					}}>
						Atenção!
					</ModalBody>
					{switchButton === 'aprovar' ?
						<ModalBody>
							<Text>
								É de extrema importância uma verificação com muita atenção aos dados do pedido solicitado.
							</Text>
							<Text>
								Lembre-se que os valores, serão debitados do seu Saldo em produtos.
							</Text>
						</ModalBody>
						:
						<ModalBody>
							<Text color="red" style={{ fontWeight: 'bold', textAlign: 'center' }}>Pense com muita atenção.</Text>
							<Text style={{ textAlign: 'center' }}>
								Ao reprovar uma cobrança não será mais possível voltar a atrás em sua escolha.
							</Text>
						</ModalBody>
					}

					<DivButton>
						<ButtonStyle
							type="button"
							style={{ backgroundColor: color.greenDark, fontSize: '15px' }}
							onClick={() => toggleModal()}>
							CANCELAR
						</ButtonStyle>
						<ButtonStyle
							type="button"
							style={{
								color: switchButton === 'aprovar' ? color.black : color.red,
								backgroundColor: switchButton === 'aprovar' ? color.greenLight : color.redLight, fontSize: '15px'
							}}
							onClick={() => {
								toggleModal()
								if (switchButton === 'aprovar') {
									setLoading(true);
									aprovarOuReprovarPedido(numPedido.toString(), 'aprovar').then(() => getPedidos(10, 1, 'enviados', '', '', '').then(res => {
										getExtrato(user.dados.documento, 1, '', '', '', '', '');
										getSaldo(user.dados.documento, '');
										setMeusPedidos(res.data.pedidos);
										setLoading(false);
									}))
									handleClickAprovarCobrança();
								} else {
									setLoading(true);
									aprovarOuReprovarPedido(numPedido.toString(), 'reprovar').then(() => getPedidos(10, 1, 'enviados', '', 'PENDENTE', '').then(res => {
										setMeusPedidos(res.data.pedidos);
										setLoading(false);
									}))
									handleClickNegarCobrança();
								}
							}}>
							{switchButton === 'aprovar' ? 'SIM, APROVAR' : 'SIM, REPROVAR'}
						</ButtonStyle>
					</DivButton>

					<ButtonStyle
						type="button"
						style={{ border: 'none', fontWeight: 'bold', fontSize: '20px' }}
						onClick={() => toggleModal()}>
						VOLTAR
					</ButtonStyle>
				</ModalContent>
			</StyledModal>
		</div>
	);
}

export default ModalVisualizar;
